<section class="p-5 lg:max-w-7xl max-w-full w-full mx-auto">
    <!-- Profile section -->
    <div class="flex flex-col items-center mb-10">
        <div class="relative mb-5">
            <img *ngIf="user.profileImage || profileImage" [src]="profileImage || user.profileImage" alt="Profile"
                class="w-28 h-28 rounded-full object-cover" />

            <div *ngIf="!user.profileImage && !profileImage"
                class="w-28 h-28 rounded-full border border-gray-300 bg-white flex items-center justify-center text-3xl font-semibold text-(--text-primary)">
                {{ user.initials }}
            </div>

            <input type="file" accept="image/*" class="hidden" #fileInput (change)="onFileSelected($event)" />
        </div>

        <p class="text-2xl font-semibold leading-7 text-(--text-primary) text-center mb-2">
            {{ user.name }}
        </p>

        <button type="button" (click)="fileInput.click()"
            class="mt-3 px-4 py-2 text-base leading-6 font-medium rounded-xl text-(--brand-primary) bg-transparent hover:opacity-80 transition cursor-pointer border">
            {{ 'SETTINGS.CHANGE_PROFILE_PIC' | translate }}
        </button>
    </div>

    <!-- Settings List -->
    <div class="space-y-8">
        <!-- Account Settings -->
        <p class="text-generic mb-4">{{ 'SETTINGS.ACCOUNT_SETTINGS' | translate }}</p>
        <div class="setting-card">
            <div class="setting-item">
                <img src="assets/icons/change-password.svg" class="w-6 h-6" />
                <div>
                    <p class="text-medium">
                        {{ 'SETTINGS.CHANGE_PASSWORD' | translate }}
                    </p>
                    <p class="text-base font-normal leading-5 text-(--text-muted)">
                        {{ 'SETTINGS.LAST_CHANGED' | translate }} {{ lastChangedDate | timeAgo }}
                    </p>
                </div>
            </div>
            <button class="setting-arrow" (click)="handleChangePasswordNav()">
                <img src="assets/icons/arrow-right-sm.svg" class="w-5 h-5 rtl:rotate-180" alt="arrow icon"/>
            </button>
        </div>

        <!-- Preferences -->
        <p class="text-generic mb-4">{{ 'SETTINGS.PREFERENCES' | translate }}</p>
        <div class="setting-card">
            <div class="setting-item">
                <img src="assets/icons/prefrences.svg" class="w-6 h-6" />
                <p class="text-medium">{{ 'SETTINGS.SET_LANGUAGE' | translate }}</p>
            </div>
            <app-language-toggle extraClass="bg-white"></app-language-toggle>
        </div>

        <!-- Help & Support -->
        <p class="text-generic mb-4">{{ 'SETTINGS.HELP_SUPPORT' | translate }}</p>
        <div class="setting-card mb-4">
            <div class="setting-item">
                <img src="assets/icons/terms-conditions.svg" class="w-6 h-6" />
                <p class="text-medium">{{ 'SETTINGS.TERMS_CONDITIONS' | translate }}</p>
            </div>
            <button class="setting-arrow" (click)="showtermsCondition()">
                <img src="assets/icons/arrow-right-sm.svg" class="w-5 h-5 rtl:rotate-180" alt="arrow icon"/>
            </button>
        </div>

        <div class="setting-card">
            <div class="setting-item">
                <img src="assets/icons/help-center.svg" class="w-6 h-6" />
                <p class="text-medium">{{ 'SETTINGS.HELP_CENTER' | translate }}</p>
            </div>
            <a routerLink="/help-center" class="setting-arrow">
                <img src="assets/icons/arrow-right-sm.svg" class="w-5 h-5 rtl:rotate-180" alt="arrow icon"/>
            </a>
        </div>
    </div>
</section>